export default __webpack_public_path__ + "static/media/portfolio-smc360-1.1651c72e.jpg";